export default {"src":"/_next/static/media/guide-logo-horizontal--color-dark.cd056c79.svg","height":32,"width":104};